module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fb-Gc-Hc-Ia.51de3877.png";